export const CAMPAIGN_CSV_DEFAULT_COLUMNS = [
	'recipientEmail',
	'contactName',
	'contactRole',
	'companyName',
	'status',
	'date',
	'openedAt',
	'clickedAt',
];

export const CAMPAIGN_CSV_COLUMN_GROUPS = {
	email: {
		label: 'E-Mail Daten',
		columns: [
			{ key: 'recipientEmail', label: 'Empfänger E-Mail' },
			{ key: 'emailSubject', label: 'E-Mail Betreff' },
			{ key: 'status', label: 'Status' },
			{ key: 'date', label: 'Datum' },
			{ key: 'openedAt', label: 'Geöffnet am' },
			{ key: 'clickedAt', label: 'Geklickt am' },
			{ key: 'unsubscribed', label: 'Abgemeldet' },
		],
	},
	contact: {
		label: 'Kontaktdaten',
		columns: [
			{ key: 'contactId', label: 'Kontakt-ID' },
			{ key: 'contactName', label: 'Kontakt Name' },
			{ key: 'contactRole', label: 'Kontakt Position' },
			{ key: 'contactEmail', label: 'Kontakt E-Mail' },
			{ key: 'contactPhone', label: 'Kontakt Telefon' },
		],
	},
	company: {
		label: 'Firmendaten',
		columns: [
			{ key: 'companyId', label: 'Unternehmens-ID' },
			{ key: 'companyName', label: 'Firmenname' },
			{ key: 'companyEmail', label: 'Firmen E-Mail' },
			{ key: 'companyPhone', label: 'Firmen Telefon' },
			{ key: 'city', label: 'Stadt' },
			{ key: 'website', label: 'Website' },
		],
	},
};
